var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "file-card",
      class: { selected: _vm.selected },
      on: {
        click: _vm.handleDoubleClick,
        contextmenu: function ($event) {
          $event.preventDefault()
          return _vm.handleContextMenu.apply(null, arguments)
        },
        mouseenter: function ($event) {
          _vm.showSelectionCircle = true
        },
        mouseleave: function ($event) {
          _vm.showSelectionCircle = false
        },
      },
    },
    [
      _vm.showSelectionCircle || _vm.selected
        ? _c(
            "div",
            {
              staticClass: "selection-circle",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.toggleSelection.apply(null, arguments)
                },
              },
            },
            [_vm.selected ? _c("i", { staticClass: "fas fa-check" }) : _vm._e()]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isImage
        ? _c(
            "div",
            { staticClass: "file-preview" },
            [
              !_vm.selectionMode
                ? _c("viewer", { attrs: { images: [_vm.previewUrl] } }, [
                    _c("img", {
                      attrs: { src: _vm.previewUrl, alt: _vm.file.name },
                      on: { click: _vm.show },
                    }),
                  ])
                : _c("img", {
                    attrs: { src: _vm.previewUrl, alt: _vm.file.name },
                  }),
            ],
            1
          )
        : _c("div", { staticClass: "file-icon-container" }, [
            _c("div", { staticClass: "file-icon" }, [
              _c("i", { class: _vm.iconClass }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "file-name" }, [
              _vm._v(_vm._s(_vm.file.name)),
            ]),
          ]),
      _vm._v(" "),
      _vm.showContextMenu
        ? _c(
            "div",
            {
              staticClass: "context-menu",
              style: {
                left: _vm.contextMenuPosition.x + "px",
                top: _vm.contextMenuPosition.y + "px",
              },
            },
            [
              _c("div", { staticClass: "context-menu-title" }, [
                _vm._v(_vm._s(_vm.$t("message.actions"))),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "context-menu-item",
                  on: { click: _vm.handleDelete },
                },
                [
                  _c("i", { staticClass: "fas fa-trash text-danger" }),
                  _vm._v(" " + _vm._s(_vm.$t("message.delete"))),
                ]
              ),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }